export type MarketingEvent =
  | 'hero_wake_started'
  | 'hero_wake_completed'
  | 'story_quiet_engine_viewed'
  | 'route_choice_changed'
  | 'system_layer_activated'
  | 'audio_enabled'
  | 'district_viewed'
  | 'ai_disclosure_opened'
  | 'cta_app_store_clicked'
  | 'cta_coming_soon_opened'

export function trackEvent(event: MarketingEvent): void {
  if (typeof navigator === 'undefined') return
  const body = JSON.stringify({ event })
  if (navigator.sendBeacon) {
    navigator.sendBeacon('/api/event', new Blob([body], { type: 'application/json' }))
    return
  }
  void fetch('/api/event', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body,
    keepalive: true,
  })
}
